import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const CalendarForm = forwardRef(({user, calendar, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={calendar}
      type="calendar"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={(update) => services.user.saveCalendar({user_id: user.id, ...update})}
      onSaved={onSaved}
    />
  );
});

export default CalendarForm;
